import { Container, Title, Text, Stack, Box, List, Alert } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { useLanguage } from '@/context/LanguageContext';
import { useSEO } from '@/lib/useSEO';

export default function ReturnsPage() {
  const { t } = useLanguage();

  // SEO for Returns page
  useSEO({
    title: t('seo.returns.title') || 'Returns & Refunds - Luxelo',
    description: t('seo.returns.description') || 'Learn about our return policy, refund process, and exchange options. Hassle-free returns within 14 days.',
    type: 'website',
  });

  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        <Box>
          <Title order={1} mb="md">{t('returns.title')}</Title>
          <Text size="lg" c="dimmed">
            {t('returns.subtitle')}
          </Text>
        </Box>

        <Alert icon={<IconInfoCircle size={16} />} color="blue" mb="md">
          {t('returns.important')}
        </Alert>

        <Box>
          <Title order={2} mb="md">{t('returns.policy.title')}</Title>
          <Text size="md" mb="md">
            {t('returns.policy.description')}
          </Text>
        </Box>

        <Box>
          <Title order={2} mb="md">{t('returns.conditions.title')}</Title>
          <List spacing="md" size="md" mb="md">
            <List.Item>{t('returns.conditions.item1')}</List.Item>
            <List.Item>{t('returns.conditions.item2')}</List.Item>
            <List.Item>{t('returns.conditions.item3')}</List.Item>
            <List.Item>{t('returns.conditions.item4')}</List.Item>
            <List.Item>{t('returns.conditions.item5')}</List.Item>
          </List>
        </Box>

        <Box>
          <Title order={2} mb="md">{t('returns.process.title')}</Title>
          <Stack gap="md">
            <Box>
              <Text fw={600} mb="xs">{t('returns.process.step1.title')}</Text>
              <Text size="sm" c="dimmed">{t('returns.process.step1.description')}</Text>
            </Box>
            <Box>
              <Text fw={600} mb="xs">{t('returns.process.step2.title')}</Text>
              <Text size="sm" c="dimmed">{t('returns.process.step2.description')}</Text>
            </Box>
            <Box>
              <Text fw={600} mb="xs">{t('returns.process.step3.title')}</Text>
              <Text size="sm" c="dimmed">{t('returns.process.step3.description')}</Text>
            </Box>
            <Box>
              <Text fw={600} mb="xs">{t('returns.process.step4.title')}</Text>
              <Text size="sm" c="dimmed">{t('returns.process.step4.description')}</Text>
            </Box>
          </Stack>
        </Box>

        <Box>
          <Title order={2} mb="md">{t('returns.refund.title')}</Title>
          <Text size="md" mb="md">
            {t('returns.refund.description')}
          </Text>
        </Box>

        <Box>
          <Title order={2} mb="md">{t('returns.exchanges.title')}</Title>
          <Text size="md" mb="md">
            {t('returns.exchanges.description')}
          </Text>
        </Box>

        <Box>
          <Title order={2} mb="md">{t('returns.contact.title')}</Title>
          <Text size="md">
            {t('returns.contact.description')}
          </Text>
        </Box>
      </Stack>
    </Container>
  );
}

